// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2zgAk","validationTips":"StatementDescriptor_validationTips__QXtkv"};